import React, { useState } from 'react';
import { isPersonalQuoteFields } from '../commercialScope.js';
import { F } from '../utils.jsx';

const INTAKE_FIELDS = [
  ['Main Challenge', '🎯 Main Challenge'],
  ['Goals', '🏁 Goals'],
  ['Current Sales Motion', '⚙️ Sales Motion'],
  ['Sales Team Size', '👥 Team Size'],
  ['Company Context', '🏢 Context'],
  ["What They've Tried", '🔄 Tried'],
  ['Pipeline Last 90 Days', '📊 Pipeline'],
  ['Prospecting Activity', '📡 Prospecting'],
  ['Messaging Examples', '✉️ Messaging'],
  ['Additional Context', '💬 Additional'],
];

function formatDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export default function AccountContactsTab({
  name, stakeholderEngagement, stakeholderSearch, setStakeholderSearch,
  bulkGeneratePainPoints, bulkPainLoading, bulkPainProgress,
  showNewStakeholder, setShowNewStakeholder,
  newStkName, setNewStkName, newStkLastName, setNewStkLastName,
  newStkRole, setNewStkRole, newStkEmail, setNewStkEmail,
  newStkPhone, setNewStkPhone, newStkLinkedin, setNewStkLinkedin,
  newStkInfluence, setNewStkInfluence, createStakeholder, creatingStk,
  setHistoryStakeholder,
  editingStkNotes, setEditingStkNotes, stkNotesValue, setStkNotesValue, saveStkNotes, savingStkNotes,
  setCpSelectedStakeholder, setCpMeetingModal, setCpMeetingNotes, setCpMeetingDate, setCpMeetingTime,
  setCpCallModal, setCpCallNotes, setCpEditingContact,
  goToMessageLab,
  selectedContactIds, setSelectedContactIds, deletingContacts, bulkDeleteContacts,
  diagnosticIntakes,
}) {
  const [expandedIntake, setExpandedIntake] = useState(null);

  const filteredEngagement = stakeholderEngagement.filter(({ s, sName }) => {
    if (!stakeholderSearch) return true;
    const term = stakeholderSearch.toLowerCase();
    return sName.toLowerCase().includes(term) || (F(s, 'Role') || '').toLowerCase().includes(term);
  });
  return (
    <div>
      <div className="card" style={{ marginBottom: 0 }}>
        <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <h3>👥 Contacts ({stakeholderEngagement.length})</h3>
            {selectedContactIds.size > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 12, color: 'var(--globant-muted)' }}>{selectedContactIds.size} elegidos</span>
                <button
                  className="action-btn"
                  style={{ fontSize: 11, padding: '4px 10px', background: 'rgba(239,68,68,0.12)', color: '#B4362C', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 6 }}
                  onClick={bulkDeleteContacts} disabled={deletingContacts}>
                  {deletingContacts ? 'Borrando…' : 'Borrar elegidos'}
                </button>
                <button className="action-btn btn-ghost" style={{ fontSize: 11 }} onClick={() => setSelectedContactIds(new Set())}>Quitar selección</button>
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input className="input-field" style={{ maxWidth: 200, fontSize: 12, padding: '6px 12px' }}
              placeholder="Buscar por nombre o cargo…"
              value={stakeholderSearch} onChange={e => setStakeholderSearch(e.target.value)} />
            <button className="action-btn btn-ghost" style={{ fontSize: 10, padding: '5px 10px', whiteSpace: 'nowrap' }}
              onClick={bulkGeneratePainPoints} disabled={bulkPainLoading}>
              {bulkPainLoading ? `⏳ ${bulkPainProgress}` : 'Generar dolores con IA'}
            </button>
            <button className="action-btn btn-primary" style={{ fontSize: 10, padding: '5px 10px', whiteSpace: 'nowrap' }}
              onClick={() => setShowNewStakeholder(!showNewStakeholder)}>
              {showNewStakeholder ? 'Cerrar' : 'Agregar contacto'}
            </button>
          </div>
        </div>

        {showNewStakeholder && (() => {
          const emailInvalid = newStkEmail.trim() !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newStkEmail.trim());
          return (
          <div className="contact-form" style={{ padding: '14px', background: 'var(--globant-darker)', borderRadius: 8, marginBottom: 12, border: '1px solid var(--globant-border)' }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--globant-green)', marginBottom: 12 }}>Nuevo contacto en {name}</div>
            <div className="form-row">
              <div className="form-field"><label htmlFor="ac-name">Nombre *</label><input id="ac-name" className="input-field" placeholder="Ej.: Ana" value={newStkName} onChange={e => setNewStkName(e.target.value)} autoFocus /></div>
              <div className="form-field"><label htmlFor="ac-last">Apellido</label><input id="ac-last" className="input-field" placeholder="Ej.: García" value={newStkLastName} onChange={e => setNewStkLastName(e.target.value)} /></div>
              <div className="form-field">
                <label htmlFor="ac-email">Email</label>
                <input id="ac-email" className="input-field" type="email" placeholder="ana@empresa.com" value={newStkEmail} onChange={e => setNewStkEmail(e.target.value)} aria-invalid={emailInvalid} aria-describedby={emailInvalid ? 'ac-email-error' : undefined} />
                {emailInvalid && <div id="ac-email-error" className="form-error">Revisá el email: parece incompleto.</div>}
              </div>
            </div>
            <details className="form-more">
              <summary>Más datos <span className="form-optional">(cargo, teléfono, LinkedIn, influencia)</span></summary>
              <div className="form-row">
                <div className="form-field"><label htmlFor="ac-role">Cargo</label><input id="ac-role" className="input-field" placeholder="Ej.: Gerente comercial" value={newStkRole} onChange={e => setNewStkRole(e.target.value)} /></div>
                <div className="form-field"><label htmlFor="ac-phone">Teléfono</label><input id="ac-phone" className="input-field" type="tel" placeholder="+56 9…" value={newStkPhone} onChange={e => setNewStkPhone(e.target.value)} /></div>
                <div className="form-field"><label htmlFor="ac-linkedin">LinkedIn</label><input id="ac-linkedin" className="input-field" placeholder="https://linkedin.com/in/…" value={newStkLinkedin} onChange={e => setNewStkLinkedin(e.target.value)} /></div>
                <div className="form-field"><label htmlFor="ac-influence">Influencia</label><select id="ac-influence" className="input-field" value={newStkInfluence} onChange={e => setNewStkInfluence(e.target.value)}><option value="">Sin definir</option><option value="High">Alta</option><option value="Medium">Media</option><option value="Low">Baja</option></select></div>
              </div>
            </details>
            <div style={{ marginTop: 14, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button type="button" className="action-btn btn-primary" onClick={createStakeholder} disabled={!newStkName.trim() || emailInvalid || creatingStk}>{creatingStk ? 'Creando…' : 'Crear contacto'}</button>
              <button type="button" className="action-btn btn-ghost" onClick={() => setShowNewStakeholder(false)}>Cancelar</button>
            </div>
          </div>
          );
        })()}

        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead><tr>
              <th style={{ width: 32 }}>
                <input type="checkbox"
                  checked={filteredEngagement.length > 0 && filteredEngagement.every(({ s }) => selectedContactIds.has(s.id))}
                  onChange={e => {
                    if (e.target.checked) setSelectedContactIds(new Set(filteredEngagement.map(({ s }) => s.id)));
                    else setSelectedContactIds(new Set());
                  }}
                />
              </th>
              <th>Nombre</th><th>Cargo</th><th>Influencia</th><th>Último contacto</th><th>Interés</th><th>Estado</th><th style={{ textAlign: 'center' }}>Acciones</th>
            </tr></thead>
            <tbody>
              {filteredEngagement
                .map(({ s, sName, hasReplied, hasMeeting, totalTouches, lastTouch, daysSince }) => {
                  const phone = F(s, 'Phone number');
                  const email = F(s, 'Email');
                  const linkedin = F(s, 'LinkedIn');
                  const isChecked = selectedContactIds.has(s.id);
                  return (
                    <React.Fragment key={s.id}>
                    <tr style={{ background: isChecked ? 'rgba(239,68,68,0.05)' : undefined }}>
                      <td onClick={e => e.stopPropagation()}>
                        <input type="checkbox" checked={isChecked} onChange={e => { const s2 = new Set(selectedContactIds); e.target.checked ? s2.add(s.id) : s2.delete(s.id); setSelectedContactIds(s2); }} />
                      </td>
                      <td style={{ fontWeight: 600, cursor: 'pointer', color: 'var(--globant-green)' }} onClick={() => setHistoryStakeholder(s)}>{sName}</td>
                      <td style={{ fontSize: 12 }}>{F(s, 'Role')}</td>
                      <td>{F(s, 'Level of Influence') ? <span className="badge badge-accent">{F(s, 'Level of Influence')}</span> : '—'}</td>
                      <td style={{ fontSize: 11, whiteSpace: 'nowrap' }}>
                        {lastTouch ? (
                          <span style={{ color: daysSince > 14 ? '#B4362C' : daysSince > 7 ? '#9A6212' : '#2D5F99', fontWeight: 600 }}>
                            {new Date(lastTouch.fields?.['Date']).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })}
                            <span style={{ fontSize: 10, opacity: 0.8, marginLeft: 4 }}>({daysSince}d)</span>
                          </span>
                        ) : <span className="badge" style={{ background: 'rgba(239,68,68,0.12)', color: '#B4362C', fontSize: 10 }}>Nunca</span>}
                      </td>
                      <td>
                        {(() => {
                          let score = 0;
                          if (hasReplied) score += 40;
                          if (hasMeeting) score += 30;
                          if (totalTouches > 0) score += Math.min(20, totalTouches * 4);
                          if (daysSince !== null) score += daysSince > 21 ? 0 : daysSince > 14 ? 5 : daysSince > 7 ? 8 : 10;
                          score = Math.min(100, score);
                          const barColor = score >= 70 ? '#1E7B4F' : score >= 40 ? '#9A6212' : '#B4362C';
                          return (
                            <div style={{ minWidth: 70 }}>
                              <div style={{ fontSize: 10, fontWeight: 700, color: barColor, marginBottom: 3 }}>{score}%</div>
                              <div style={{ height: 4, borderRadius: 2, background: 'rgba(30,42,44,0.08)', overflow: 'hidden' }}>
                                <div style={{ height: '100%', width: `${score}%`, background: barColor, borderRadius: 2 }} />
                              </div>
                            </div>
                          );
                        })()}
                      </td>
                      <td>
                        {hasMeeting ? <span className="badge badge-blue">Reunión</span> :
                         hasReplied ? <span className="badge badge-green">Respondió</span> :
                         totalTouches > 0 ? <span className="badge badge-yellow">Esperando</span> :
                         <span className="badge" style={{ background: 'rgba(239,68,68,0.15)', color: '#B4362C' }}>Sin contacto</span>}
                      </td>
                      <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                        <div style={{ display: 'flex', gap: 4, justifyContent: 'center' }}>
                          {email && <button title="Laboratorio de mensajes" style={{ background: 'rgba(91,191,181,0.12)', border: '1px solid rgba(91,191,181,0.3)', borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 13 }} onClick={() => goToMessageLab ? goToMessageLab(s.id) : setCpSelectedStakeholder(s)}>✉️</button>}
                          <button title="Agendar reunión" style={{ background: 'rgba(96,165,250,0.12)', border: '1px solid rgba(96,165,250,0.3)', borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 13 }} onClick={() => { setCpMeetingModal({ stakeholder: s }); setCpMeetingNotes(''); setCpMeetingDate(''); setCpMeetingTime(''); }}>📅</button>
                          {phone && <button title="Registrar llamada" style={{ background: 'rgba(251,191,36,0.12)', border: '1px solid rgba(251,191,36,0.3)', borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 13 }} onClick={() => { setCpCallModal(s); setCpCallNotes(''); }}>📞</button>}
                          {phone && <button title="WhatsApp" style={{ background: 'rgba(37,211,102,0.12)', border: '1px solid rgba(37,211,102,0.3)', borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 13 }} onClick={() => window.open('https://wa.me/' + String(phone).replace(/[^0-9+]/g, ''), '_blank')}>💬</button>}
                          {linkedin && <button title="LinkedIn" style={{ background: 'rgba(10,102,194,0.12)', border: '1px solid rgba(10,102,194,0.3)', borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 12, fontWeight: 700, color: '#0A66C2' }} onClick={() => window.open(linkedin, '_blank')}>in</button>}
                          <button title="Notas" style={{ background: F(s,'Intel Notes') ? 'rgba(251,191,36,0.15)' : 'rgba(30,42,44,0.05)', border: `1px solid ${F(s,'Intel Notes') ? 'rgba(251,191,36,0.3)' : 'var(--globant-border)'}`, borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 13, color: F(s,'Intel Notes') ? '#9A6212' : 'var(--globant-muted)' }}
                            onClick={() => { if (editingStkNotes === s.id) { setEditingStkNotes(null); } else { setStkNotesValue(F(s,'Intel Notes') || ''); setEditingStkNotes(s.id); } }}>🗒️</button>
                          <button title="Editar" style={{ background: 'rgba(30,42,44,0.05)', border: '1px solid var(--globant-border)', borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 13, color: 'var(--globant-muted)' }} onClick={() => setCpEditingContact(s)}>✏️</button>
                          {(() => {
                            // Company activity: never a personal quote of this contact (src/quoteChains.js › kindOf)
                            const stkIntakes = (diagnosticIntakes || []).filter(r => {
                              const ids = r.fields?.['Stakeholder'];
                              return Array.isArray(ids) && ids.includes(s.id) && !isPersonalQuoteFields(r.fields || {});
                            });
                            if (!stkIntakes.length) return null;
                            const isOpen = expandedIntake === s.id;
                            return (
                              <button
                                title={`${stkIntakes.length} intake${stkIntakes.length > 1 ? 's' : ''}`}
                                style={{ background: isOpen ? 'rgba(91,191,181,0.2)' : 'rgba(91,191,181,0.08)', border: `1px solid rgba(91,191,181,${isOpen ? '0.5' : '0.25'})`, borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 13, color: 'var(--globant-green)', position: 'relative' }}
                                onClick={() => setExpandedIntake(isOpen ? null : s.id)}>
                                📋
                                <span style={{ position: 'absolute', top: -4, right: -4, background: 'var(--globant-green)', color: '#0e1117', borderRadius: 8, fontSize: 9, fontWeight: 700, padding: '1px 4px', lineHeight: 1.4 }}>{stkIntakes.length}</span>
                              </button>
                            );
                          })()}
                        </div>
                      </td>
                    </tr>
                    {expandedIntake === s.id && (() => {
                      const stkIntakes = (diagnosticIntakes || []).filter(r => {
                        const ids = r.fields?.['Stakeholder'];
                        return Array.isArray(ids) && ids.includes(s.id);
                      }).sort((a, b) => (b.fields?.['Submitted At'] || '').localeCompare(a.fields?.['Submitted At'] || ''));
                      return (
                        <tr>
                          <td colSpan={8} style={{ padding: '0 12px 16px', background: 'rgba(91,191,181,0.03)', borderBottom: '1px solid rgba(91,191,181,0.12)' }}>
                            <div style={{ paddingTop: 12, display: 'flex', flexDirection: 'column', gap: 16 }}>
                              {stkIntakes.map((intake, i) => (
                                <div key={intake.id} style={{ background: 'rgba(30,42,44,0.03)', border: '1px solid rgba(30,42,44,0.07)', borderRadius: 8, padding: '12px 16px' }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                    <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--globant-green)' }}>
                                      Intake #{stkIntakes.length - i}
                                    </span>
                                    <span style={{ fontSize: 11, color: 'var(--globant-muted)' }}>
                                      {formatDate(intake.fields?.['Submitted At'])} · {intake.fields?.['Form Language'] === 'es' ? 'ES' : 'EN'}
                                    </span>
                                  </div>
                                  <div style={{ display: 'grid', gap: 8 }}>
                                    {INTAKE_FIELDS.map(([field, label]) => {
                                      const val = intake.fields?.[field];
                                      if (!val) return null;
                                      return (
                                        <div key={field}>
                                          <div style={{ fontSize: 10, fontWeight: 600, color: 'var(--globant-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2 }}>{label}</div>
                                          <div style={{ fontSize: 12, color: 'var(--globant-text)', lineHeight: 1.55, whiteSpace: 'pre-wrap' }}>{val}</div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      );
                    })()}
                    {editingStkNotes === s.id && (
                      <tr>
                        <td colSpan={8} style={{ padding: '0 12px 12px', background: 'rgba(251,191,36,0.04)', borderBottom: '1px solid rgba(251,191,36,0.1)' }}>
                          <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', paddingTop: 10 }}>
                            <textarea
                              autoFocus
                              value={stkNotesValue}
                              onChange={e => setStkNotesValue(e.target.value)}
                              placeholder="Lo que sabés de este contacto — rol real, intereses, cómo habla, qué le preocupa..."
                              className="input-field"
                              style={{ flex: 1, fontSize: 12, lineHeight: 1.6, minHeight: 72, resize: 'vertical' }}
                            />
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                              <button className="action-btn btn-primary" style={{ fontSize: 11 }} onClick={() => saveStkNotes(s)} disabled={savingStkNotes}>
                                {savingStkNotes ? '⏳' : '💾'}
                              </button>
                              <button className="action-btn btn-ghost" style={{ fontSize: 11 }} onClick={() => setEditingStkNotes(null)}>✕</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    </React.Fragment>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
